(ns common.schema.entities.survey-cycle.core
  (:require
   [common.schema.entities.survey-cycle.permissions :as permissions]
   [common.schema.entities.survey-cycle.schema :as schema]))

(def entity-type-definition
  {:entity-type                  :entity.type/survey-cycle
   :schema                       schema/schema
   :name                         {:en "Survey cycle"}
   :plural                       {:en "Survey cycles"}
   :icon                         :fa-calendar
   :display-name-template        "{{survey-cycle/cycle-label}}"
   :display-name/depends-on      [:survey-cycle/cycle-label]
   :permissions                  {:creatable?   true
                                  :disableable? true}
   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
